const AgentCashDrawerDriver = require('@/lib/CashDrawer/Drivers/AgentCashDrawerDriver');
const AgentService = require('@/lib/Agent/AgentService');
const ApiClient = require('@/lib/Api/ApiClient');
const ApiRequestParams = require('@/libraries/DigiTickets/Api/ApiRequestParams');
const AppConfig = require('@/lib/Config/AppConfig');
const AvailablePrintersManager = require('@/lib/Printing/AvailablePrintersManager');
const CartLineNumberFactory = require('@/libraries/DigiTickets/Cart/CartLineNumberFactory');
const CartLineSplitter = require('@/libraries/DigiTickets/Cart/CartLineSplitter');
const CartService = require('@/libraries/DigiTickets/Cart/CartService');
const CartStasher = require('@/libraries/DigiTickets/CartStasher');
const CartStashHelper = require('@/lib/StashedCarts/CartStashHelper');
const CartToConfirmationStructureMapper = require('@/libraries/DigiTickets/Cart/CartToConfirmationStructureMapper');
const CartToOrderMapper = require('@/libraries/DigiTickets/Mappers/CartToOrderMapper');
const CartToReservationStructureMapper = require('@/libraries/DigiTickets/Cart/CartToReservationStructureMapper');
const CashDrawerService = require('@/lib/CashDrawer/CashDrawerService');
const CategoryRepository = require('@/lib/Categories/CategoryRepository');
const CheckoutService = require('@/lib/Checkout/CheckoutService');
const ClubcardTokenApplicator = require('@/lib/Clubcard/ClubcardTokenApplicator');
const ConnectivityChecker = require('@/libraries/DigiTickets/ConnectivityChecker');
const ContactService = require('@/lib/Contacts/ContactService');
const CountryManager = require('@/lib/Countries/CountryManager');
const CurrencyService = require('@/lib/Currency/CurrencyService');
const CurrentDevice = require('@/libraries/DigiTickets/CurrentDevice');
const CustomerAccountService = require('@/libraries/DigiTickets/CustomerAccountService');
const CustomerScreenDataService = require('@/libraries/DigiTickets/CustomerScreenDataService');
const DataStore = require('@/libraries/DigiTickets/DataStore');
const DataStoreTester = require('@/libraries/DigiTickets/DataStoreTester');
const DeviceLockService = require('@/lib/Devices/DeviceLockService');
const DeviceLoginListener = require('@/libraries/DigiTickets/Auth/DeviceLoginListener');
const DeviceManager = require('@/libraries/DigiTickets/DeviceManager');
const DialogService = require('@/libraries/DigiTickets/DialogService');
const EInvoicingService = require('@/lib/Invoicing/EInvoicingService');
const EntraIDAuthService = require('@/lib/Auth/EntraIDAuthService');
const ErrorPresenter = require('@/libraries/DigiTickets/Errors/ErrorPresenter');
const EventBus = require('@/lib/Events/EventBus');
const EventsByCategoryService = require('@/lib/Sessions/EventsByCategoryService');
const ExternalCartCalculator = require('@/libraries/DigiTickets/Cart/ExternalCartCalculator');
const FieldDataService = require('@/lib/CustomFields/FieldDataService');
const FieldInstanceFactory = require('@/lib/CustomFields/FieldInstanceFactory');
const FieldRepository = require('@/lib/CustomFields/FieldRepository');
const FieldValidator = require('@/lib/CustomFields/FieldValidator');
const GiftAidPrompter = require('@/libraries/DigiTickets/GiftAid/GiftAidPrompter');
const GiftAidRateRepository = require('@/lib/GiftAidRates/GiftAidRateRepository');
const GiftVoucherRepository = require('@/lib/GiftVouchers/GiftVoucherRepository');
const GiftVoucherValidator = require('@/lib/GiftVouchers/GiftVoucherValidator');
const GoCardlessService = require('@/lib/PaymentMethods/GoCardless/GoCardlessService');
const Hydrator = require('@/lib/Hydration/Hydrator');
const ImageRepository = require('@/lib/Images/ImageRepository');
const ItemBarcodeRepository = require('@/lib/Barcodes/ItemBarcodeRepository');
const ItemBarcodeService = require('@/lib/Barcodes/ItemBarcodeService');
const ItemInstanceOrderMapRepository = require('@/lib/Orders/ItemInstanceOrderMapRepository');
const ItemOptionConfigValidator = require('@/lib/ItemOptions/ItemOptionConfigValidator');
const ItemOptionManager = require('@/lib/ItemOptions/ItemOptionManager');
const ItemOptionRepository = require('@/lib/ItemOptions/ItemOptionRepository');
const ItemRepository = require('@/lib/Items/ItemRepository');
const KeyboardInputDetector = require('@/lib/Input/KeyboardInputDetector');
const KitchenOrderFactory = require('@/lib/Kitchen/KitchenOrderFactory');
const KitchenReceiptPrinter = require('@/lib/Kitchen/KitchenReceiptPrinter');
const KitchenService = require('@/lib/Kitchen/KitchenService');
const KitchenZoneRepository = require('@/lib/Kitchen/KitchenZoneRepository');
const LandingPageService = require('@/libraries/DigiTickets/LandingPageService');
const LangService = require('@/lib/Lang/LangService');
const LocalStorageDataStore = require('@/libraries/DigiTickets/LocalStorageDataStore');
const LoginService = require('@/lib/Auth/LoginService');
const LogoService = require('@/libraries/DigiTickets/LogoService');
const MarketingPreferenceAsker = require('@/libraries/DigiTickets/Customers/MarketingPreferences/MarketingPreferenceAsker');
const MarketingPreferenceRepository = require('@/lib/MarketingPreferences/MarketingPreferenceRepository');
const MellonWebECRDriver = require('@/lib/PaymentMethods/MellonWebECR/MellonWebECRDriver');
const MembershipCancellationRunner = require('@/lib/Memberships/MembershipCancellationRunner');
const MembershipManagementService = require('@/lib/Memberships/MembershipManagementService');
const MembershipPlanRepository = require('@/lib/Memberships/MembershipPlanRepository');
const MembershipRedemptionService = require('@/lib/Memberships/MembershipRedemptionService');
const MembershipRefGenerator = require('@/lib/Memberships/MembershipRefGenerator');
const MembershipService = require('@/lib/Memberships/MembershipService');
const MembershipValidator = require('@/libraries/DigiTickets/Memberships/MembershipValidator');
const ModalFactory = require('@/libraries/DigiTickets/ModalFactory');
const NavigationService = require('@/libraries/DigiTickets/NavigationService');
const NumPadFactory = require('@/lib/UI/NumPad/NumPadFactory');
const OfferApplicator = require('@/lib/Offers/OfferApplicator');
const OfferRepository = require('@/lib/Offers/OfferRepository');
const OnlineQueue = require('@/lib/OnlineQueue/OnlineQueue');
const OnlineTaskRepository = require('@/lib/OnlineQueue/OnlineTaskRepository');
const OptionSetRepository = require('@/lib/ItemOptions/OptionSetRepository');
const OrderAdjustmentConfirmer = require('@/libraries/DigiTickets/Orders/Adjustments/OrderAdjustmentConfirmer');
const OrderConfirmer = require('@/lib/Orders/OrderConfirmer');
const OrderDownloader = require('@/lib/Orders/OrderDownloader');
const OrderFieldInstancesFromApiBuilder = require('@/lib/CustomFields/OrderFieldInstancesFromApiBuilder');
const OrderFulfillmentService = require('@/libraries/DigiTickets/Fulfillments/OrderFulfillmentService');
const OrderInProgressStasher = require('@/lib/StashedCarts/OrderInProgressStasher');
const OrderQueue = require('@/lib/Orders/OrderQueue');
const OrderReceiptPrinter = require('@/lib/Printing/OrderReceiptPrinter');
const OrderRelationAttacher = require('@/lib/Orders/OrderRelationAttacher');
const OrderRepository = require('@/lib/Orders/OrderRepository');
const OrderRequestSubmitter = require('@/lib/Orders/OrderRequestSubmitter');
const OrdersApi = require('@/lib/Orders/OrdersApi');
const OrderSearcher = require('@/lib/Orders/OrderSearcher');
const OrderService = require('@/lib/Orders/OrderService');
const PaymentExpressDriver = require('@/lib/PaymentMethods/PaymentExpress/PaymentExpressDriver');
const PaymentMethodService = require('@/lib/PaymentMethods/PaymentMethodService');
const PaymentService = require('@/libraries/DigiTickets/Payment/PaymentService');
const PaymentState = require('@/libraries/DigiTickets/Payment/PaymentState');
const PricingRuleCalculator = require('@/lib/PricingRules/PricingRuleCalculator');
const Printer = require('@/lib/Printing/Printer');
const PrinterAppPrintDriver = require('@/lib/Printing/Drivers/PrinterAppPrintDriver');
const PrintRouter = require('@/lib/Printing/PrintRouter');
const PrivilegesManager = require('@/lib/Privileges/PrivilegesManager');
const PrivilegesRepository = require('@/lib/Privileges/PrivilegesRepository');
const ProductAvailabilityChecker = require('@/libraries/DigiTickets/Cart/ProductAvailabilityChecker');
const ProductRepository = require('@/lib/Products/ProductRepository');
const ReceiptPrinter = require('@/lib/Printing/ReceiptPrinter');
const RedemptionScanHandler = require('@/lib/Redemption/RedemptionScanHandler');
const RedemptionService = require('@/lib/Redemption/RedemptionService');
const RefValidator = require('@/libraries/DigiTickets/RefValidator');
const ReservationService = require('@/lib/Reservations/ReservationService');
const ReturnReasonRepository = require('@/lib/ReturnReasons/ReturnReasonRepository');
const SaleableItemService = require('@/lib/Items/SaleableItemService');
const SavedAddressManager = require('@/lib/Addresses/SavedAddressManager');
const SearchContext = require('@/libraries/DigiTickets/SearchContext');
const SellService = require('@/lib/Sell/SellService');
const SessionAvailabilityService = require('@/lib/Sessions/SessionAvailabilityService');
const SessionCalendarPopulator = require('@/lib/Sessions/SessionCalendarPopulator');
const SessionEventRepository = require('@/lib/Sessions/SessionEventRepository');
const SessionRepository = require('@/lib/Sessions/SessionRepository');
const SessionSpaceCalculatorFactory = require('@/lib/Sessions/SessionSpaceCalculatorFactory');
const SoldGiftVoucherManager = require('@/libraries/DigiTickets/SoldGiftVoucherManager');
const StaffRefValidator = require('@/lib/Cart/StaffRefValidator');
const StashMetadataService = require('@/lib/StashedCarts/StashMetadataService');
const SyncedDataManager = require('@/lib/Syncing/SyncedDataManager');
const SyncStateManager = require('@/lib/Syncing/SyncStateManager');
const TaxManager = require('@/lib/Tax/TaxManager');
const TemplateCompiler = require('@/libraries/DigiTickets/Templates/TemplateCompiler');
const TemplateRepository = require('@/lib/Templates/TemplateRepository');
const ThemeManager = require('@/libraries/DigiTickets/ThemeManager');
const ThirdPartyRefGenerator = require('@/libraries/DigiTickets/Cart/ThirdPartyRefGenerator');
const TicketRedeemer = require('@/lib/Redemption/TicketRedeemer');
const TicketRepository = require('@/lib/Tickets/TicketRepository');
const TimeSyncer = require('@/lib/Clock/TimeSyncer');
const ToastFactory = require('@/libraries/DigiTickets/ToastFactory');
const TradingSessionManager = require('@/lib/TradingSessions/TradingSessionManager');
const UserService = require('@/libraries/DigiTickets/UserService');
const UserSessionManager = require('@/libraries/DigiTickets/UserSessions/UserSessionManager');
const UserSwitcher = require('@/libraries/DigiTickets/UserSessions/UserSwitcher');
const VueModalFactory = require('@/lib/Modals/VueModalFactory').default; // .default at the end because the file uses an ES6 export instead of module.exports
const VuexService = require('@/lib/Vue/VuexService');
const WaiversService = require('@/lib/Waivers/WaiversService');
const WebsocketService = require('@/lib/Websocket/WebsocketService');
const { ClubcardService } = require('@/lib/Clubcard/ClubcardService');
const { OfferService } = require('@/lib/Offers/OfferService');
const { SyncRunner } = require('@/lib/Syncing/SyncRunner');

/**
 * This tells Angular how to resolve dependencies when doing its automatic
 * Dependency Injection (DI). In Angular these are called Providers.
 * See {@link https://docs.angularjs.org/guide/providers} for more details.
 *
 * Where a provider is more complex than just a simple list of dependencies,
 * we create a dedicated file within this same directory.
 *
 * Each call to app.service here registers a service with that name and the specified implementation.
 * The string is the name that can be used to inject the instance. it is best to keep this name and the name of the
 * implementing class the same if possible.
 * e.g. Don't call the service XService if the class is called XManager. Pick one and stick with it.
 *
 * The first time a service needs to be injected the given implementation will be new'd and that instance remembered.
 * The same instance will be re-used for all subsequent calls.
 *
 * @param {angular.Module} app
 */
const registerAngularServices = (app) => {
    app.service('agentCashDrawerDriver', AgentCashDrawerDriver);
    app.service('agentService', AgentService);
    app.service('apiClient', ApiClient);
    app.service('apiRequestParams', ApiRequestParams);
    app.service('appConfig', AppConfig);
    app.service('availablePrintersManager', AvailablePrintersManager);
    app.service('cartLineNumberFactory', CartLineNumberFactory);
    app.service('cartLineSplitter', CartLineSplitter);
    app.service('cartService', CartService);
    app.service('cartStasher', CartStasher);
    app.service('cartStashHelperService', CartStashHelper);
    app.service('cartToConfirmationStructureMapper', CartToConfirmationStructureMapper);
    app.service('cartToOrderMapper', CartToOrderMapper);
    app.service('cartToReservationStructureMapper', CartToReservationStructureMapper);
    app.service('cashDrawerService', CashDrawerService);
    app.service('categoryRepository', CategoryRepository);
    app.service('checkoutService', CheckoutService);
    app.service('clubcardService', ClubcardService);
    app.service('clubcardTokenApplicator', ClubcardTokenApplicator);
    app.service('connectivityChecker', ConnectivityChecker);
    app.service('contactService', ContactService);
    app.service('countryManager', CountryManager);
    app.service('currencyService', CurrencyService);
    app.service('currentDevice', CurrentDevice);
    app.service('customerAccountService', CustomerAccountService);
    app.service('customerScreenDataService', CustomerScreenDataService);
    // A factory rather than a service because the DataStore has to be given its database before anything uses it.
    app.factory('dataStore', () => {
        const dataStore = new DataStore();
        dataStore.init();

        return dataStore;
    });
    app.service('dataStoreTester', DataStoreTester);
    app.service('deviceLockService', DeviceLockService);
    app.service('deviceLoginListener', DeviceLoginListener);
    app.service('deviceManager', DeviceManager);
    app.service('dialogService', DialogService);
    app.service('entraIDAuthService', EntraIDAuthService);
    app.service('errorPresenter', ErrorPresenter);
    app.service('eInvoicingService', EInvoicingService);
    app.service('eventBus', EventBus);
    app.service('eventsByCategoryService', EventsByCategoryService);
    app.service('externalCartCalculator', ExternalCartCalculator);
    app.service('fieldDataService', FieldDataService);
    app.service('fieldInstanceFactory', FieldInstanceFactory);
    app.service('fieldRepository', FieldRepository);
    app.service('fieldValidator', FieldValidator);
    app.service('giftAidPrompter', GiftAidPrompter);
    app.service('giftAidRateRepository', GiftAidRateRepository);
    app.service('giftVoucherRepository', GiftVoucherRepository);
    app.service('giftVoucherValidator', GiftVoucherValidator);
    app.service('goCardlessService', GoCardlessService);
    app.service('hydrator', Hydrator);
    app.service('imageRepository', ImageRepository);
    app.service('itemBarcodeRepository', ItemBarcodeRepository);
    app.service('itemBarcodeService', ItemBarcodeService);
    app.service('itemInstanceOrderMapRepository', ItemInstanceOrderMapRepository);
    app.service('itemOptionConfigValidator', ItemOptionConfigValidator);
    app.service('itemOptionManager', ItemOptionManager);
    app.service('itemOptionRepository', ItemOptionRepository);
    app.service('itemRepository', ItemRepository);
    app.service('keyboardInputDetector', KeyboardInputDetector);
    app.service('kitchenOrderFactory', KitchenOrderFactory);
    app.service('kitchenZoneRepository', KitchenZoneRepository);
    app.service('kitchenReceiptPrinter', KitchenReceiptPrinter);
    app.service('kitchenService', KitchenService);
    app.service('landingPageService', LandingPageService);
    app.service('langService', LangService);
    app.service('localStorageDataStore', LocalStorageDataStore);
    app.service('loginService', LoginService);
    app.service('logoService', LogoService);
    app.service('marketingPreferenceAsker', MarketingPreferenceAsker);
    app.service('marketingPreferenceRepository', MarketingPreferenceRepository);
    app.service('membershipCancellationRunner', MembershipCancellationRunner);
    app.service('membershipManagementService', MembershipManagementService);
    app.service('membershipPlanRepository', MembershipPlanRepository);
    app.service('membershipRedemptionService', MembershipRedemptionService);
    app.service('membershipRefGenerator', MembershipRefGenerator);
    app.service('membershipService', MembershipService);
    app.service('membershipValidator', MembershipValidator);
    app.service('mellonWebECRDriver', MellonWebECRDriver);
    app.service('modalFactory', ModalFactory);
    app.service('navigationService', NavigationService);
    app.service('numPadFactory', NumPadFactory);
    app.service('offerApplicator', OfferApplicator);
    app.service('offerRepository', OfferRepository);
    app.service('offerService', OfferService);
    app.service('optionSetRepository', OptionSetRepository);
    app.service('onlineQueue', OnlineQueue);
    app.service('onlineTaskRepository', OnlineTaskRepository);
    app.service('orderAdjustmentConfirmer', OrderAdjustmentConfirmer);
    app.service('orderConfirmer', OrderConfirmer);
    app.service('orderDownloader', OrderDownloader);
    app.service('orderFieldInstancesFromApiBuilder', OrderFieldInstancesFromApiBuilder);
    app.service('orderFulfillmentService', OrderFulfillmentService);
    app.service('orderInProgressStasher', OrderInProgressStasher);
    app.service('orderQueue', OrderQueue);
    app.service('orderReceiptPrinter', OrderReceiptPrinter);
    app.service('orderRelationAttacher', OrderRelationAttacher);
    app.service('orderRepository', OrderRepository);
    app.service('orderRequestSubmitter', OrderRequestSubmitter);
    app.service('ordersApi', OrdersApi);
    app.service('orderSearcher', OrderSearcher);
    app.service('orderService', OrderService);
    app.service('paymentExpressDriver', PaymentExpressDriver);
    app.service('paymentMethodService', PaymentMethodService);
    app.service('paymentService', PaymentService);
    app.service('paymentState', PaymentState);
    app.service('pricingRuleCalculator', PricingRuleCalculator);
    app.service('printer', Printer);
    app.service('printerAppPrintDriver', PrinterAppPrintDriver);
    app.service('printRouter', PrintRouter);
    app.service('privilegesManager', PrivilegesManager);
    app.service('privilegesRepository', PrivilegesRepository);
    app.service('productAvailabilityChecker', ProductAvailabilityChecker);
    app.service('productRepository', ProductRepository);
    app.service('receiptPrinter', ReceiptPrinter);
    app.service('redemptionScanHandler', RedemptionScanHandler);
    app.service('redemptionService', RedemptionService);
    app.service('refValidator', RefValidator);
    app.service('reservationService', ReservationService);
    app.service('returnReasonRepository', ReturnReasonRepository);
    app.service('saleableItemService', SaleableItemService);
    app.service('savedAddressManager', SavedAddressManager);
    app.service('searchContext', SearchContext);
    app.service('sellService', SellService);
    app.service('sessionAvailabilityService', SessionAvailabilityService);
    app.service('sessionCalendarPopulator', SessionCalendarPopulator);
    app.service('sessionEventRepository', SessionEventRepository);
    app.service('sessionRepository', SessionRepository);
    app.service('sessionSpaceCalculatorFactory', SessionSpaceCalculatorFactory);
    app.service('soldGiftVoucherManager', SoldGiftVoucherManager);
    app.service('staffRefValidator', StaffRefValidator);
    app.service('stashMetadataService', StashMetadataService);
    app.service('syncedDataManager', SyncedDataManager);
    app.service('syncRunner', SyncRunner);
    app.service('syncStateManager', SyncStateManager);
    app.service('taxManager', TaxManager);
    app.service('templateCompiler', TemplateCompiler);
    app.service('templateRepository', TemplateRepository);
    app.service('themeManager', ThemeManager);
    app.service('thirdPartyRefGenerator', ThirdPartyRefGenerator);
    app.service('ticketRedeemer', TicketRedeemer);
    app.service('ticketRepository', TicketRepository);
    app.service('timeSyncer', TimeSyncer);
    app.service('toastFactory', ToastFactory);
    app.service('tradingSessionManager', TradingSessionManager);
    app.service('userService', UserService);
    app.service('userSessionManager', UserSessionManager);
    app.service('userSwitcher', UserSwitcher);
    app.service('vueModalFactory', VueModalFactory);
    app.service('vuexService', VuexService);
    app.service('waiversService', WaiversService);
    app.service('websocketService', WebsocketService);
};

module.exports = registerAngularServices;
